import { render } from "./DeleteRecordDialog.vue?vue&type=template&id=df11182a"
import script from "./DeleteRecordDialog.vue?vue&type=script&lang=js"
export * from "./DeleteRecordDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__